/**
 * The blocks /privacy is built from, by id.
 *
 * Each list drives both the page (`pages/public/Privacy.tsx` renders
 * `privacyPage.<family>.<id>.*` from it) and `locales/docs/siteKeys.test.ts`,
 * which fails if any locale lacks a key the page will ask for. Add an id here
 * and every catalog must grow the matching keys.
 *
 * What each item may claim is fixed by the facts in
 * docs/superpowers/specs/2026-10-25-privacy-page-redesign-design.md §5.
 */

/** The three ways to use Sokuji, one hero card each; `kizuna` is the highlighted one. */
export const PRIVACY_WAYS = ['ownKey', 'kizuna', 'local'] as const;

/** Section 01, what reaches the AI provider you chose. */
export const PRIVACY_DEST_PROVIDER = ['voices', 'screen', 'text', 'voiceSample'] as const;
/** Section 01, what reaches Kizuna AI (only with a Kizuna AI account). */
export const PRIVACY_DEST_KIZUNA = ['email', 'logins', 'billing', 'feedback'] as const;
/** Section 01, what stays with you. */
export const PRIVACY_DEST_DEVICE = ['history', 'settings', 'local'] as const;

/** Section 01, services that receive data but no meeting content. */
export const PRIVACY_THIRD_PARTIES = ['posthog', 'stripe'] as const;

/** Section 02, one table row each: what we keep, why, and for how long. */
export const PRIVACY_STORED = ['email', 'logins', 'abuseIps', 'trial', 'billing', 'feedback'] as const;

/** Section 03, ways to check the content claims without taking our word. */
export const PRIVACY_CHECKS = ['code', 'network', 'offline'] as const;

/** Section 04. */
export const PRIVACY_PROMISES = ['noSale', 'noTraining', 'trust'] as const;
